export function def<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isNonEmptyString(value: string | null | undefined): value is string {
  return value !== null && value !== undefined && value !== '';
}

export type NonEmptyArray<T> = [T, ...T[]];
export function isNonEmptyArray<T>(value: T[] | null | undefined): value is NonEmptyArray<T> {
  return value !== null && value !== undefined && value.length > 0;
}

export function EmptyFn() {}

export function EmptyPromiseFn<T>(input: T) {
  return () => Promise.resolve(input);
}

export function anyOf<T>(value: T, ...allowedValues: Array<T>): boolean {
  return allowedValues.includes(value);
}
